"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = exports.SearchInputDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_debounce_1 = require("../../hooks/use-debounce");
var icon_1 = require("./icon");
var icons_1 = require("../icons");
var SearchCircle = icons_1.Icons.SearchCircle;
exports.SearchInputDefaultProps = {
  value: '',
  onChange: function (value) {},
  autoFocus: false,
  placeholder: "Enter Search Term"
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    position: relative;\n    align-items: center;\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    position: relative;\n    align-items: center;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: none;\n    font-family: ", ";\n    font-size: ", ";\n    background: none;\n    margin: 0;\n    width: 100%;\n    max-width: 600px;\n    cursor: text;\n    border-radius: 0;\n    font-weight: 500;\n    color: ", ";\n    padding: ", " 2px;\n    -webkit-appearance: none;\n    \n    &::placeholder {\n      color: ", ";\n      font-weight: 500;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  "], ["\n    border: none;\n    font-family: ", ";\n    font-size: ", ";\n    background: none;\n    margin: 0;\n    width: 100%;\n    max-width: 600px;\n    cursor: text;\n    border-radius: 0;\n    font-weight: 500;\n    color: ", ";\n    padding: ", " 2px;\n    -webkit-appearance: none;\n    \n    &::placeholder {\n      color: ", ";\n      font-weight: 500;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(16), theme_1.theme.COLOR('primary'), theme_1.theme.UNIT(3), theme_1.theme.COLOR('text')),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " 2px;\n  "], ["\n    padding: ", " 2px;\n  "])), theme_1.theme.UNIT(4))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n    margin-left: 1px;\n    flex-shrink: 0;\n    ", ";\n  "], ["\n    margin-right: ", ";\n    margin-left: 1px;\n    flex-shrink: 0;\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FILL('dark')),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Input: styled_components_1.default.input(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var SearchInput = function (props) {
  var onChange = props.onChange,
    placeholder = props.placeholder,
    autoFocus = props.autoFocus;
  var _a = __read(React.useState(''), 2),
    value = _a[0],
    setValue = _a[1];
  var debouncedValue = (0, use_debounce_1.useDebounce)(value, 500);
  React.useEffect(function () {
    onChange(value);
  }, [debouncedValue]);
  var onInputChange = function (e) {
    var newValue = e.target.value;
    setValue(newValue);
  };
  var ref = React.useRef();
  var className = props.className;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Icon, {
    size: 24
  }, React.createElement(SearchCircle, null)), React.createElement(My.Input, {
    ref: ref,
    placeholder: placeholder,
    value: value,
    onChange: onInputChange
  }));
};
exports.SearchInput = SearchInput;
exports.SearchInput.defaultProps = exports.SearchInputDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;